import styled from "styled-components";
import { responsive } from "../../styles/constants.style";

export const ViewUserWrapper = styled.div`
  .user-role-email-grid {
    padding: 0 0 30px 16px;
    ${responsive.MOBILE`
      padding: 0px 16px 16px;
    `}
  }

  .user-detail-grid {
    padding: 0 0 30px 16px;
    ${responsive.MOBILE`
      padding: 0px 16px 16px;
    `}
  }
`;
